import { useState } from 'react';

export function useToggle(
  defaultState: boolean
  // boolValues?: { true: string; false: string }
) {
  const [value, setValue] = useState(defaultState);

  const toggle = () => setValue(!value);

  // const getValue = () =>
  // boolValues ? boolValues[value.toString() as "true" | "false"] : value;

  return { value, toggle, setValue };
}
